import { render, staticRenderFns } from "./checkType.vue?vue&type=template&id=7c8c9c8c"
import script from "./checkType.vue?vue&type=script&lang=js"
export * from "./checkType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports